export const PERMS = {
    READ: 'report_vehicle_fuelings.read',
    EXPORT: 'report_vehicle_fuelings.export',
}
